import { ThemingContext, Text } from '@doordash/design-language';
import './components/styles/Input.js';
import './components/styles/Time.js';
import './components/styles/Select.js';
import './components/styles/Field.js';
import { PasswordToggle } from './components/styles/Password.js';
import PropTypes from 'prop-types';
import RawTextField from './components/RawTextField.js';
import React__default from 'react';
import { SizeSemantics } from './components/constants.js';
import omit from 'lodash.omit';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PasswordField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PasswordField, _React$PureComponent);

  var _super = _createSuper(PasswordField);

  function PasswordField() {
    var _this;

    _classCallCheck(this, PasswordField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      contentHidden: !_this.props.defaultShowPassword
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      _this.setState(function (currentState) {
        return {
          contentHidden: !currentState.contentHidden
        };
      });
    });

    return _this;
  }

  _createClass(PasswordField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var contentHidden = this.state.contentHidden;
      var strings = this.props.strings;
      return /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, this.props, {
        type: contentHidden ? 'password' : 'text',
        renderAfterContent: function renderAfterContent() {
          return /*#__PURE__*/React__default.createElement(PasswordToggle, {
            onClick: _this2.handleToggle
          }, /*#__PURE__*/React__default.createElement(Text, {
            styles: Text.Styles["".concat(SizeSemantics[_this2.props.size], "Button")]
          }, contentHidden ? strings.show : strings.hide));
        },
        hasDefaultRenderContent: true
      }));
    }
  }]);

  return PasswordField;
}(React__default.PureComponent);

_defineProperty(PasswordField, "contextType", ThemingContext);

PasswordField.Sizes = RawTextField.Sizes;
PasswordField.propTypes = _objectSpread(_objectSpread({}, omit(RawTextField.propTypes, ['type', 'isMultiline'])), {}, {
  defaultShowPassword: PropTypes.bool,
  strings: PropTypes.shape({
    show: PropTypes.string.isRequired,
    hide: PropTypes.string.isRequired
  })
});
PasswordField.defaultProps = _objectSpread(_objectSpread({}, RawTextField.defaultProps), {}, {
  defaultShowPassword: false,
  strings: {
    show: 'Show',
    hide: 'Hide'
  }
});

export { PasswordField as default };
